import { IconName } from '@fortawesome/fontawesome-svg-core'
import IconWithBackground from '../IconWithBackground/IconWithBackground'

interface DashboardNotificationProps {
    iconName: IconName
    children?: React.ReactNode
}

const DashboardNotification = ({ iconName, children }: DashboardNotificationProps) => {
    return (
        <div className='shadow-sm border-full bg-white rounded-xl flex items-center gap-x-2 p-3'>
            <IconWithBackground iconName={iconName} size='small' />
            {children}
        </div>
    )
}

export default DashboardNotification
